<template>
  <div class="form-module">
    <p class="module-title">{{ $locale("rules.salesSettings") }}</p>
    <div class="key-block">
      <div class="block-r">
        <div class="sale-time">
          <div class="sale-time-window">
            <TimeItem
              v-bind:formObj="form.posStartSale"
              v-bind:keyName="'posStartSale'"
              v-bind:options="startType"
              v-bind:labelText="$locale('rules.salesStartTime') + '（' + $locale('global.window') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <TimeItem
              v-bind:formObj="form.posEndSale"
              v-bind:keyName="'posEndSale'"
              v-bind:options="endType"
              v-bind:labelText="$locale('rules.salesEndTime') + '（' + $locale('global.window') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <!-- <div class="clearfix" v-for="(item, index) in form.posPreSaleRule" :key="index">
              <el-form-item :label="index === 0 ? $locale('rules.preSaleRank') + '（' + $locale('global.window') + '）' : ''" class="w315">
                <el-select v-model="item.membershipRankId">
                  <el-option v-for="(rank) in rankList" :label="rank.name" :value="rank.id" :key="rank.id" :disabled="$_.some(form.posPreSaleRule, { membershipRankId: rank.id })"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="index === 0 ? $locale('rules.preSaleTime') + '（' + $locale('global.window') + '）' : ''" class="w315">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-input v-model="item.timeAmount" @input="(val) => numberInput(val, 'posPreSaleRule', index)" />
                  </el-col>
                  <el-col :span="8">
                    <el-select v-model="item.timeUnit">
                      <el-option label="日" value="day"></el-option>
                      <el-option label="時間" value="hour"></el-option>
                      <el-option label="分" value="minute"></el-option>
                    </el-select> 
                  </el-col>
                  <el-col :span="8" style="width: 110px;">
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="removePreSaleObj('posPreSaleRule', index)" v-if="form.posPreSaleRule.length > 1">
                      <i class="el-icon-minus"></i>
                    </el-button>
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="addPreSaleObj('posPreSaleRule')" v-if="index === form.posPreSaleRule.length - 1">
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-col> 
                </el-row>
              </el-form-item>
            </div> -->
            <div class="clearfix">
              <el-form-item :label="$locale('rules.maxNumOfPurchases') + '（' + $locale('global.POS') + '）*'" class="w315">
                <el-input v-model="form.seatMaxPos" @input="setMaxBuy('seatMaxPos')"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="sale-time-web">
            <TimeItem
              v-bind:formObj="form.webStartSale"
              v-bind:keyName="'webStartSale'"
              v-bind:options="startType"
              v-bind:labelText="$locale('rules.salesStartTime') + '（' + $locale('global.bookOnline') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <TimeItem
              v-bind:formObj="form.webEndSale"
              v-bind:keyName="'webEndSale'"
              v-bind:options="endType"
              v-bind:labelText="$locale('rules.salesEndTime') + '（' + $locale('global.bookOnline') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <div class="clearfix" v-for="(item, index) in form.webPreSaleRule" :key="index">
              <el-form-item :label="index === 0 ? $locale('rules.preSaleRank') + '（' + $locale('global.bookOnline') + '）' : ''" class="w315">
                <el-select v-model="item.membershipRankId">
                  <el-option v-for="(rank) in rankList" :label="rank.name" :value="rank.id" :key="rank.id" :disabled="$_.some(form.webPreSaleRule, { membershipRankId: rank.id })"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="index === 0 ? $locale('rules.preSaleTime') + '（' + $locale('global.bookOnline') + '）' : ''" class="w315">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-input v-model="item.timeAmount" @input="(val) => numberInput(val, 'webPreSaleRule', index)"/>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-model="item.timeUnit">
                      <el-option label="日" value="day"></el-option>
                      <el-option label="時間" value="hour"></el-option>
                      <el-option label="分" value="minute"></el-option>
                    </el-select> 
                  </el-col>
                  <el-col :span="8" style="width: 110px;">
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="removePreSaleObj('webPreSaleRule', index)" v-if="form.webPreSaleRule.length > 1">
                      <i class="el-icon-minus"></i>
                    </el-button>
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="addPreSaleObj('webPreSaleRule')" v-if="index === form.webPreSaleRule.length - 1">
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-col> 
                </el-row>
              </el-form-item>
            </div>
            <div class="clearfix">
              <el-form-item :label="$locale('rules.maxNumOfPurchases') + '（' + $locale('global.bookOnline') + '）*'" class="w315">
                <el-input v-model="form.seatMaxWeb" @input="setMaxBuy('seatMaxWeb')"></el-input>
              </el-form-item>
            </div>
            <div class="clearfix">
              <el-form-item :label="$locale('rules.maxNumOfPurchases') + '（' + $locale('dailyDetail.preSale') + '）*'" class="w315">
                <el-input v-model="form.webPreSaleSeatMax" @input="setMaxBuy('webPreSaleSeatMax')"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <br />
        <div class="sale-time">
          <div class="sale-time-window">
            <TimeItem
              v-bind:formObj="form.scStartSale"
              v-bind:keyName="'scStartSale'"
              v-bind:options="startType"
              v-bind:labelText="$locale('rules.salesStartTime') + '（' + $locale('global.selfCashier') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <TimeItem
              v-bind:formObj="form.scEndSale"
              v-bind:keyName="'scEndSale'"
              v-bind:options="endType"
              v-bind:labelText="$locale('rules.salesEndTime') + '（' + $locale('global.selfCashier') + '）*'"
              @setValue="setValue"
            ></TimeItem>
            <!-- <div class="clearfix" v-for="(item, index) in form.scPreSaleRule" :key="index">
              <el-form-item :label="index === 0 ? $locale('rules.preSaleRank') + '（' + $locale('global.selfCashier') + '）' : ''" class="w315">
                <el-select v-model="item.membershipRankId">
                  <el-option v-for="(rank) in rankList" :label="rank.name" :value="rank.id" :key="rank.id" :disabled="$_.some(form.scPreSaleRule, { membershipRankId: rank.id })"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="index === 0 ? $locale('rules.preSaleTime') + '（' + $locale('global.selfCashier') + '）' : ''" class="w315">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-input v-model="item.timeAmount" @input="(val) => numberInput(val, 'scPreSaleRule', index)"/>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-model="item.timeUnit">
                      <el-option label="日" value="day"></el-option>
                      <el-option label="時間" value="hour"></el-option>
                      <el-option label="分" value="minute"></el-option>
                    </el-select> 
                  </el-col>
                  <el-col :span="8" style="width: 110px;">
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="removePreSaleObj('scPreSaleRule', index)" v-if="form.scPreSaleRule.length > 1">
                      <i class="el-icon-minus"></i>
                    </el-button>
                    <el-button class="handle-btn egl-btn-white-gray-border" @click="addPreSaleObj('scPreSaleRule')" v-if="index === form.scPreSaleRule.length - 1">
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-col> 
                </el-row>
              </el-form-item>
            </div> -->
            <div class="clearfix">
              <el-form-item :label="$locale('rules.maxNumOfPurchases') + '（' + $locale('global.selfCheckout') + '）*'" class="w315">
                <el-input v-model="form.seatMaxSelfCashier" @input="setMaxBuy('seatMaxSelfCashier')"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <el-row>
      <el-col :span="8">
        <el-form-item label="車椅子席販売可能" style="width: auto !important;">
          <div class="undisplay-btn">
            <el-button
              :class="formObj.ticketRule[btn.key] || formObj.ticketRule[btn.key] === null ? 'egl-btn-white' : 'egl-btn-white-gray-border'"
              v-for="btn in btnList"
              :key="btn.key"
              @click="chooseDisplay(btn.key)"
            >{{ btn.text }}</el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="key-block">
      <div class="block-r">
        <div class="sale-time">
          <div class="sale-time-window">
            <el-form-item :label="$locale('rules.standingmax')" class="w315">
              <el-input v-model="form.standingmax" :placeholder="$locale('rules.standingmax.p')"></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
    <div :style="{'margin-bottom':'20px'}">
    <p class="module-title" :style="{'display':'inline'}">{{ $locale("rules.confirmtemplate") }}</p>
     <i class="el-icon-question" />
    </div>
    <div class="key-block">
      <div class="block-r">
        <div class="sale-time">
          <div class="offse-hours">
            <TimeItem
              v-bind:formObj="form.advanced"
              v-bind:keyName="'advanced'"
              v-bind:options="confirmOptions"
              v-bind:labelText="$locale('rules.confirmoptions')"
              @setValue="setValue"
            ></TimeItem>
          </div>
        </div>
      </div>
    </div>
    <el-row>
      <el-col>
        <el-form-item :label="$locale('rules.alertMessage')" style="width: 100%;">
          <el-row v-for="(item, idx) in form.customizeMsg" :key="idx" :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="4">
              <el-select v-model="item.deviceType">
                <el-option
                  v-for="device in deviceList"
                  :label="device.label"
                  :value="device.value"
                  :key="device.value"
                  :disabled="isPlatformDisabled(device.value, idx)"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-input v-model="item.message"></el-input>
            </el-col>
            <el-col :span="4">
              <el-button class="handle-btn egl-btn-white-gray-border" v-if="form.customizeMsg.length >= 2" @click="removeWarningMsgItem(idx)">
                <i class="el-icon-minus"></i>
              </el-button>
              <el-button class="handle-btn egl-btn-white-gray-border" v-if="idx == form.customizeMsg.length - 1 && form.customizeMsg.length < deviceList.length" @click="addWarningMsgItem">
                <i class="el-icon-plus"></i>
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import DailyMovieRevenueReportCreate from '../../views/report/dailyMovieRevenueReport/DailyMovieRevenueReportCreate.vue';
import TimeItem from "./TimeItem.vue";
import CommDatePicker from "@/components/common/CommDatePicker";

import { getMemberShipListService } from "@/helpers/service/api/membership";

import { NumberVa } from "@/utils/inputValidation"

export default {
  name: "ruleTemplateTimeModule",
  inject: [ "setDisplayPlatform" ],
  data() {
    return {
      form: {
        seatMaxPos: 10,
        seatMaxSelfCashier: 10,
        seatMaxWeb: 10,
        webPreSaleSeatMax: 10,
        posStartSale: {},
        posEndSale: {},
        webStartSale: {},
        webEndSale: {},
        scStartSale: {},
        scEndSale: {},
        standingmax:0,
        advanced: {},
        customizeMsg: [],
        rankList: [],
      },
      confirmOptions: [
        {
          label: this.$locale("rules.confirm.option.1"),
          value: "now",
        },
        {
          label: this.$locale("rules.confirm.option.2"),
          value: "hour",
        },
        {
          label: this.$locale("rules.confirm.option.3"),
          value: "day",
        },
        {
          label: this.$locale("rules.screeningDate_specialTime"),
          value: "actionDay",
        },
        {
          label: this.$locale("rules.screeningDate_fromHour"),
          value:"date"

        },
      ],
      startType: [
        {
          label: this.$locale("rules.screeningDate_fromDay"),
          value: "day",
        },
        {
          label: this.$locale("rules.screeningDate_fromMinute"),
          value: "hour",
        },
        {
          label: this.$locale("rules.screeningDate_fromHour"),
          value: "date",
        },
        {
          label: this.$locale("rules.screeningDate_specialTime"),
          value: "actionDay",
        },
      ],
      endType: [
        {
          label: this.$locale("rules.screeningDate_untilDay"),
          value: "day",
        },
        {
          label: this.$locale("rules.screeningDate_untilMinute"),
          value: "minute",
        },
        {
          label: this.$locale("rules.screeningDate_untilAfterMinute"),
          value: "afterMinute",
        },
        {
          label: this.$locale("rules.screeningDate_untilHour"),
          value: "date",
        }
      ],
      deviceList: [
        {
          label: this.$locale("global.POS"),
          value: "POS",
        },
        {
          label: this.$locale("global.scanner"),
          value: "SCANNER",
        },
        {
          label: this.$locale("global.online"),
          value: "WEB",
        },
        {
          label: this.$locale("global.selfCashier"),
          value: "SELFCASHIER",
        }
      ],
      btnList: [
        {
          text: this.$locale("global.POS"),
          key: "wheelchairDisplayPos",
        },
        {
          text: this.$locale("global.selfCashier"),
          key: "wheelchairDisplaySelfCashier",
        },
        {
          text: this.$locale("global.online"),
          key: "wheelchairDisplayWeb",
        }
      ],
      rankList: [],
      preSaleRankList: [{
        membershipRankId: "",
        preSaleDateNum: null,
        preSaleDateNumType: "minute",
      }],
    };
  },
  mounted() {
    getMemberShipListService({
      brandId: window.localStorage.getItem("brandId"),
      page: 0, 
      pageSize: 99999,
    }).then((res) => {
      this.rankList = this.$_.flattenDeep(res.data.data.map((item) => {
        return item.rankList.map((rank) => ({
          id: rank.uuid,
          name: `[${item.name}]-[${rank.name}]`,
        }))
      }))
    })
  },
  methods: {
    setValue(keyName, obj) {
      let form = { ...this.form };

      form[keyName] = { ...obj };
      this.form = form;
    },
    setMaxBuy(keyName) {
      let inputNum = this.form[keyName];

      inputNum = parseFloat(inputNum.toString().replace(/[^\d]/g, "")) || "";

      this.form[keyName] = inputNum;
    },
    addWarningMsgItem() {
      if (this.form.customizeMsg.length >= this.deviceList.length) { return; }
      let newWarningMsg = [ ...this.form.customizeMsg ];
      let warningLength = newWarningMsg.length;

      if (newWarningMsg[warningLength - 1].deviceType != "" && newWarningMsg[warningLength - 1].message != "") {
        newWarningMsg.push({
          deviceType: "",
          message: "",
        });
      }

      this.form = { ...this.form, customizeMsg: newWarningMsg };
    },
    removeWarningMsgItem(idx) {
      let newWarningMsg = [ ...this.form.customizeMsg ];

      newWarningMsg.splice(idx, 1);
      this.form = { ...this.form, customizeMsg: newWarningMsg };
    },
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.customizeMsg.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
    chooseDisplay(keyName) {
      const keyValue = this.form[keyName] === null ? false : !this.formObj.ticketRule[keyName];
      // this.$emit("setModule", { [keyName]: keyValue });
      this.setDisplayPlatform(keyName, keyValue);
    },
    addPreSaleObj(type) {
      this.form[type].push({
        membershipRankId: "",
        timeAmount: null,
        timeUnit: "minute",
      })
    },
    removePreSaleObj(type,idx) {
      this.form[type].splice(idx, 1);
    },
    numberInput(val,type, index) {
      this.form[type][index].timeAmount = NumberVa(val);
    },
  },
  components: {
    TimeItem,
    CommDatePicker,
    // DailyMovieRevenueReportCreate,
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    formObj() {
      this.form = {
        seatMaxPos: this.formObj.ticketRule.seatMaxPos,
        seatMaxSelfCashier: this.formObj.ticketRule.seatMaxSelfCashier,
        seatMaxWeb: this.formObj.ticketRule.seatMaxWeb,
        webPreSaleSeatMax: this.formObj.ticketRule.webPreSaleSeatMax,
        posStartSale: { ...this.formObj.ticketRule.posStartSale },
        posEndSale: { ...this.formObj.ticketRule.posEndSale },
        webStartSale: { ...this.formObj.ticketRule.webStartSale },
        webEndSale: { ...this.formObj.ticketRule.webEndSale },
        webPreSaleRule: this.formObj.ticketRule.webPreSaleRule,
        posPreSaleRule: this.formObj.ticketRule.posPreSaleRule,
        scPreSaleRule: this.formObj.ticketRule.scPreSaleRule,
        scStartSale: { ...this.formObj.ticketRule.scStartSale },
        scEndSale: { ...this.formObj.ticketRule.scEndSale },
        standingmax: this.formObj.ticketRule.standingmax,
        advanced: this.formObj.ticketRule.advanced,
        customizeMsg: !this.formObj.ticketRule.customizeMsg || this.formObj.ticketRule.customizeMsg.length === 0 ? [ {
          deviceType: "",
          message: "",
        } ] : this.formObj.ticketRule.customizeMsg,
        displayOnline: this.formObj.displayOnline,
        displayPos: this.formObj.displayPos,
        displaySelfCashier: this.formObj.displaySelfCashier,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.undisplay-btn {
    display: inline-block;
    width: 100%;

    .el-button {
      // font-size: 16px;
      // height: 50px;
      // margin-right: 15px;
      min-width: 140px;

      &:hover,
      &:focus {
        background-color: @pure-white;
      }

      &:focus {
        color: @primary-black;
        background-color: @pure-white;
      }
    }

    .egl-btn-white {
      color: @other-grey;
      border-color: @primary-orange;
      background-color: @secondly-orange;

      &:hover,
      &:focus {
        color: @primary-black;
        border-color: @primary-orange;
        background-color: @secondly-orange;
      }
    }
  }
</style>
